import { gql } from "graphql-request";

const SERVER_DELETE_VACATION = gql`
mutation SERVER_DeleteVacation($id: ID!, $force: Boolean) {
  deleteVacation(id: $id, force: $force)
}
`;
export default SERVER_DELETE_VACATION;
